export const UserContextLocalStorageKey = 'nif-refund-client-context-';
export const OrgApplicationFiltersLocalStorageKey = 'nif-refund-client-org-application-filters-';
export const OrgApplicationTableOptionsLocalStorageKey = 'nif-refund-client-org-application-table-options-';
export const RemovedInfoMessagesLocalStorageKey = "nif-removed-messages-";